module.exports = __webpack_public_path__ + "img/yyzs_qrcode.169bfbf2.jpg";